<template>
  <div class="view-community-forums">
    <community-shell
      :community-id="$route.params.id"
      active="forum"
      :search="search"
      @search="search = $event"
    >
      <h5 class="forums-title">Fóruns</h5>
      <forum-list :community-id="$route.params.id" :search="search" />
    </community-shell>
  </div>
</template>

<script>
import CommunityShell from "@/components/community/CommunityShell.vue";
import ForumList from "@/components/community/ForumList.vue";

export default {
  name: "ForumsView",
  components: { CommunityShell, ForumList },
  data() {
    return {
      search: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.view-community-forums {
  .forums-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }
}
</style>
